import React from 'react';
import styled from 'styled-components';

const AboutSection = styled.section`
  padding: 80px 0;
  background-color: var(--light-color);
`;

const AboutContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 50px;
  align-items: center;
`;

const AboutText = styled.div`
  h2 {
    color: var(--primary-color);
    margin-bottom: 20px;
    font-size: 2.5rem;
  }
  
  p {
    margin-bottom: 20px;
  }
`;

const Values = styled.div`
  margin-top: 40px;
`;

const ValueItem = styled.div`
  display: flex;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ValueNumber = styled.div`
  font-size: 1.5rem;
  color: var(--accent-color);
  font-weight: bold;
  margin-right: 15px;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-color);
  color: white;
  border-radius: 50%;
  
  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

const ValueText = styled.div`
  h3 {
    color: var(--primary-color);
    margin-bottom: 5px;
  }
`;

function About() {
  return (
    <AboutSection id="ueber-uns" className="about">
      <div className="container">
        <AboutContent className="about-content">
          <AboutText className="about-text">
            <h2>GuardiansMoves — Ihr zuverlässiger Partner in Berlin</h2>
            <p>
              GuardiansMoves ist Ihr Spezialist für Sicherheitsdienste, Taxi & Mietwagenservice 
              und Reinigung in Berlin und Brandenburg. Als Einzelunternehmen unter der Leitung von 
              Galal Aldien Mghames bieten wir maßgeschneiderte Lösungen für Privatkunden 
              und Geschäftskunden in der Hauptstadtregion.
            </p>
            <p>
              Unsere Stärken liegen in der persönlichen Betreuung und der hohen Qualität unserer 
              Dienstleistungen. Seit unserer Gründung orientieren wir uns stets an den individuellen 
              Bedürfnissen unserer Berliner Kunden und erarbeiten passgenaue Konzepte für 
              jeden Anspruch.
            </p>
            
            <Values className="values">
              <ValueItem className="value-item">
                <ValueNumber className="value-number">01</ValueNumber>
                <ValueText className="value-text">
                  <h3>Höchste Qualität</h3>
                  <p>
                    Alle unsere Dienstleistungen in Berlin werden nach höchsten Qualitätsstandards 
                    durchgeführt. Wir legen größten Wert auf Zuverlässigkeit, Pünktlichkeit und 
                    Professionalität bei jedem Auftrag.
                  </p>
                </ValueText>
              </ValueItem>
              
              <ValueItem className="value-item">
                <ValueNumber className="value-number">02</ValueNumber>
                <ValueText className="value-text">
                  <h3>Individuelle Kundenorientierung</h3>
                  <p>
                    Ihre Zufriedenheit steht für uns an erster Stelle. Wir gehen individuell 
                    auf Ihre Wünsche ein und finden die optimale Lösung für Ihre Anforderungen 
                    in Berlin und Umgebung.
                  </p>
                </ValueText>
              </ValueItem>
              
              <ValueItem className="value-item">
                <ValueNumber className="value-number">03</ValueNumber>
                <ValueText className="value-text">
                  <h3>Maximale Flexibilität</h3>
                  <p>
                    Ob kurzfristige Anfragen oder langfristige Planung — wir sind flexibel 
                    und passen uns Ihren Bedürfnissen an. Rund um die Uhr für Sie erreichbar 
                    im gesamten Berliner Stadtgebiet.
                  </p>
                </ValueText>
              </ValueItem>
              
              <ValueItem className="value-item">
                <ValueNumber className="value-number">04</ValueNumber>
                <ValueText className="value-text">
                  <h3>Garantierte Sicherheit</h3>
                  <p>
                    Ihre Sicherheit hat für uns oberste Priorität. Unsere speziell geschulten 
                    Mitarbeiter sind bestens ausgebildet und sorgen für einen reibungslosen 
                    Ablauf jeder Dienstleistung in Berlin.
                  </p>
                </ValueText>
              </ValueItem>
            </Values>
          </AboutText>
        </AboutContent>
      </div>
    </AboutSection>
  );
}

export default About;